export class GravesConstants {
    static pageHeader = "Graves";
}
